import { useApiClient } from "../../../hooks/useApiClient";
import useSWR from "swr";
import {
  type IMonitoringNotificationsResponse,
  type IMonitoringNotificationsObject,
} from "../types";

interface IResponse {
  data: IMonitoringNotificationsObject[];
  isLoading: boolean;
}

export const useMonitoringNotifications = (): IResponse => {
  const { apiClient } = useApiClient();

  // swrに引き渡すfetcher
  const fetcher = async (
    url: string
  ): Promise<IMonitoringNotificationsResponse> => {
    const { data } = await apiClient.get<IMonitoringNotificationsResponse>(url);
    return data;
  };

  const toObjectList = (
    data: IMonitoringNotificationsResponse | undefined
  ): IMonitoringNotificationsObject[] => {
    if (data === undefined) return [];
    return data.list;
  };

  const { data: importStatuses, isLoading } = useSWR(
    "/monitoring/notification",
    fetcher,
    {
      revalidateOnFocus: true,
      refreshInterval: 1000 * 30,
    }
  );

  return { data: toObjectList(importStatuses), isLoading };
};
